import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "../lib/api";

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="relative bg-brand-blue text-white overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="text-[11px] tracking-[0.3em] uppercase text-white/80 mb-6 flex items-center gap-3">
          <span className="h-px w-8 bg-white/70" />
          Call today · Free same-day quote
        </div>

        <motion.a
          href={BRAND.phoneHref}
          data-testid="footer-phone"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.6, 0.05, 0.15, 1] }}
          className="block font-display uppercase leading-[0.85] tracking-tight text-[18vw] md:text-[14vw] lg:text-[11vw] hover:text-white/90 transition-colors"
        >
          {BRAND.phone}
        </motion.a>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16 text-white/90 border-t border-white/20 pt-10">
          <div className="flex items-start gap-3">
            <Phone className="h-5 w-5 mt-1 shrink-0" />
            <div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/70 mb-1">Call</div>
              <a href={BRAND.phoneHref} className="font-display text-2xl uppercase tracking-wide">
                {BRAND.phone}
              </a>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Mail className="h-5 w-5 mt-1 shrink-0" />
            <div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/70 mb-1">Email</div>
              <a href={BRAND.emailHref} className="font-display text-2xl uppercase tracking-wide break-all">
                {BRAND.email}
              </a>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <MapPin className="h-5 w-5 mt-1 shrink-0" />
            <div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/70 mb-1">Area</div>
              <div className="font-display text-2xl uppercase tracking-wide">
                Montgomery, AL <br />& Surrounding Areas
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row md:items-center justify-between gap-4 text-[10px] tracking-[0.3em] uppercase text-white/70">
          <span>© {new Date().getFullYear()} RRR Paint & Construction LLC. All rights reserved.</span>
          <div className="flex items-center gap-6">
            <span>Residential · Commercial</span>
            <a href="/admin" data-testid="admin-link" className="link-underline">
              Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
